import React from "react";

import {
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";

const useStyles = (searchColor) =>
  makeStyles((theme) => ({
    adornment: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      backgroundColor: "white",
      height: 55,
      width: 50,
      borderRadius: theme.spacing(0, 4, 4, 0),
    },
    textField: {
      fontSize: "12px !important",
      width: "100%",
      [`& fieldset`]: {
        borderRadius: theme.spacing(4),
        border: searchColor && "1px solid rgba(226, 19, 110, 1)",
        background: searchColor && "rgba(226, 19, 110, 0.04)",
      },

      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        background: "white",
        padding: 4,
        borderRadius: 5,
        transform: "translate(14px, -11px) scale(.9)",
        fontSize: "12px !important",
        color: searchColor && "rgba(226, 19, 110, 1)",
      },

      "& .MuiInputBase-root": {
        height: "55px",
        "& .MuiOutlinedInput-notchedOutline": {
          "& legend": {
            maxWidth: 0,
          },
        },
      },
    },
    textFieldInput: {
      fontSize: "12px !important",
      color: theme.palette.primary.main,
      minHeight: 20,
      borderRadius: "32px !important",
      background: "white !important",
    },
    textFieldLabel: {
      textAlign: "initial",
      fontSize: "14px !important",
      margin: 0,
      ontFamily: "Inter",
    },
  }));

function BaseInput({ endAdornment, startAdornment, searchColor, ...rest }) {
  const classes = useStyles(searchColor)();

  return (
    <TextField
      variant="outlined"
      margin="normal"
      fullWidth
      autoComplete="off"
      className={classes.textField}
      InputLabelProps={{
        className: classes.textFieldLabel,
        shrink: true,
      }}
      InputProps={{
        startAdornment: startAdornment,
        endAdornment: endAdornment,
        classes: {
          input: classes.textFieldInput,
        },
      }}
      {...rest}
    />
  );
}

export default function SearchInput({ onEndIconClick, ...rest }) {
  const classes = useStyles();
  return (
    <BaseInput
      type={"text"}
      searchColor
      startAdornment={
        <div className={classes.adornment}>
          <InputAdornment position="start">
            <IconButton
              aria-label="search box"
              edge="end"
              style={{ marginLeft: "-8px" }}
              onClick={onEndIconClick}
            >
              <Search style={{ color: "rgba(226, 19, 110, 1)" }} />
            </IconButton>
          </InputAdornment>
        </div>
      }
      {...rest}
    />
  );
}
